var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50.83,85.62h-24.34v-4.85c0-1.62-1.31-2.94-2.94-2.94H7.26c-1.62,0-2.94,1.31-2.94,2.94v16.3c0,1.62,1.31,2.94,2.94,2.94h16.3c1.62,0,2.94-1.31,2.94-2.94v-5.58h24.34c1.62,0,2.94-1.31,2.94-2.94s-1.31-2.94-2.94-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.46,28.92c.75,0,1.5-.29,2.08-.86l10.94-10.94h6.41c1.62,0,2.94-1.31,2.94-2.94s-1.31-2.94-2.94-2.94h-6.97L16.53.86c-1.15-1.15-3-1.15-4.15,0L.86,12.38c-1.15,1.15-1.15,3,0,4.15l11.52,11.52c.57.57,1.32.86,2.08.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.15,65.84c5.9,0,10.83-4.23,11.93-9.81h7.69c1.62,0,2.94-1.31,2.94-2.94s-1.31-2.94-2.94-2.94h-7.98c-1.51-5-6.16-8.65-11.64-8.65-6.71,0-12.17,5.46-12.17,12.17s5.46,12.17,12.17,12.17Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m71.47,4.81h-4.95c-21.47,0-35.22,22.84-25.19,41.81l23.61,44.65c1.72,3.25,6.37,3.25,8.09,0l23.61-44.65c10.04-18.98-3.72-41.81-25.19-41.81Zm-2.47,42.02c-7.53,0-13.65-6.12-13.65-13.65s6.12-13.65,13.65-13.65,13.65,6.12,13.65,13.65-6.12,13.65-13.65,13.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocales);
export default __webpack_public_path__ + "static/media/locales.fa5d438259cc16114e807f4e9cc4a2c6.svg";
export { ForwardRef as ReactComponent };